import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import Notification from '../notification/Notification';
import { QRCodeCanvas } from 'qrcode.react';
import '../../styles/BinancePayPayment.css';
import { useNavigate } from 'react-router-dom';

const BinancePayPayment = ({ amount }) => {
    const [orderUrl, setOrderUrl] = useState('');
    const [notification, setNotification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        checkPaymentStatus();
    }, []);

    const checkPaymentStatus = async () => {
        try {
            const response = await axiosInstance.get('/api/binance/verify-binance-order');

            if (response.data && response.data.status === 'COMPLETED') {
                setNotification({ message: 'Payment completed successfully. Redirecting...', isError: false });
                navigate('/user-resume');
            } else if (response.data.status === 'PENDING') {
                setNotification({ message: 'Your Binance payment is pending. Please complete it, or use an alternative payment method to access your resume.', isError: false });
            } else {
                // console.log("Payment status unknown. Please check your payment or try again later")
                // setNotification({ message: 'Payment status unknown. Please check your payment or try again later.', isError: true });
            }
        } catch (error) {
            //  console.error('Error checking payment status:', error);
            setNotification({ message: 'Error checking payment status. Please try again later.', isError: true });
        }
    };

    const handlePayment = async () => {
        setIsLoading(true);
        try {
           // console.log('Creating Binance order with amount:', amount);
            const response = await axiosInstance.post('/api/binance/create-binance-order', { amount });
            //console.log('Response from creating Binance order:', response.data);

            if (response.data && response.data.checkoutUrl) {
                setOrderUrl(response.data.checkoutUrl);
                setNotification({ message: 'Order created successfully. Please complete your payment using the provided link.', isError: false });
            } else {
                const details = typeof response.data.details === 'object'
                    ? JSON.stringify(response.data.details)
                    : response.data.details || 'Failed to create order.';
                setNotification({ message: `Error: ${details}`, isError: true });
            }
        } catch (error) {
            const errorMsg = error.response?.data?.details
                ? (typeof error.response.data.details === 'object'
                    ? JSON.stringify(error.response.data.details)
                    : error.response.data.details)
                : 'Error creating order. Please try again later.';
            setNotification({ message: errorMsg, isError: true });
            // console.error('Failed to create order:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="binance-payment-container">
            <h2>Pay with Binance Pay</h2>
            <div>
                <label>Amount to pay:</label>
                <div>{amount} USDT</div>
            </div>
            {!orderUrl && (
                <button onClick={handlePayment} disabled={isLoading}>
                    {isLoading ? 'Generating Order...' : 'Pay with Binance Pay'}
                </button>
            )}
            {orderUrl && (
                <div className="checkout-link">
                    <a href={orderUrl} target="_blank" rel="noopener noreferrer">Complete Payment</a>
                    <QRCodeCanvas value={orderUrl} />
                </div>
            )}
            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}
        </div>
    );
};

export default BinancePayPayment;
